import { createContext } from 'react';
export var Context = /*#__PURE__*/createContext({
  prefix: 'theme-arco'
});